/**
 * Sizes the newsletter stack to the description's longest rendered
 * text line (glyph edge), so the form's right edge matches the text
 * above it — e.g. the right edge of "and" — not the full block box.
 */
(function () {
  function measureTextWidth(desc) {
    var range = document.createRange();
    range.selectNodeContents(desc);
    var rects = range.getClientRects();
    if (!rects.length) return 0;

    var left = Infinity;
    var right = -Infinity;
    for (var i = 0; i < rects.length; i++) {
      left = Math.min(left, rects[i].left);
      right = Math.max(right, rects[i].right);
    }
    return Math.ceil(right - left);
  }

  function sync(root) {
    var desc = root.querySelector('.paw-pure-footer-newsletter__desc');
    if (!desc) return;

    // Measure at the wrap constraint (max-width), not the already-shrunk width
    root.style.removeProperty('--pp-newsletter-align-width');
    void root.offsetWidth;

    var width = measureTextWidth(desc);
    if (width <= 0) return;

    root.style.setProperty('--pp-newsletter-align-width', width + 'px');
  }

  function initAll() {
    document.querySelectorAll('[data-newsletter-align]').forEach(function (root) {
      sync(root);

      if (typeof ResizeObserver === 'undefined') return;
      if (root._ppNewsletterRo) return;

      var ro = new ResizeObserver(function () {
        sync(root);
      });
      root._ppNewsletterRo = ro;
      ro.observe(root.parentElement || root);
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    initAll();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(initAll).catch(function () {});
    }
  });
  document.addEventListener('shopify:section:load', initAll);
  window.addEventListener('resize', initAll);
})();
